












import Vue from "vue";
import { TranslatedExpression } from '@/models';

interface Props {
  value: TranslatedExpression;
}

export default Vue.extend<Props>({
  name: "BaseInputSubmit",
  functional: true,
  props: {
    value: { type: Object, required: true }
  }
});
